import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix YEN icon. Exported from Figma (Bombiix 2026). */
const YENIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <mask id="yen-icon-mask" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="5" y="4" width="10" height="12">
      <rect x="5.33301" y="4" width="9.33333" height="12" fill="white" />
    </mask>
    <g mask="url(#yen-icon-mask)">
      <path
        d="M6 2.66602L10 9.99935M10 9.99935L14 2.66602M10 9.99935H6M10 9.99935H14M10 9.99935V12.666M10 15.9993V12.666M10 12.666H6M10 12.666H14"
        stroke="currentColor"
      />
    </g>
  </svg>
);

export default YENIcon;
